import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMonitoring = ({ batches, metrics }) => {
  const operatorPerformance = [
    { id: 'OP-001', name: 'Jean Dupont', batches: 12, efficiency: 96, quality: 98 },
    { id: 'OP-002', name: 'Marie Martin', batches: 15, efficiency: 94, quality: 97 },
    { id: 'OP-003', name: 'Pierre Bernard', batches: 10, efficiency: 92, quality: 95 }
  ];

  const machineEfficiency = [
    { id: 'M-001', name: 'Imprimante 3D A', utilization: 87, uptime: 98, batches: 18 },
    { id: 'M-002', name: 'Imprimante 3D B', utilization: 92, uptime: 96, batches: 22 },
    { id: 'M-003', name: 'Fraiseuse CNC', utilization: 78, uptime: 94, batches: 14 }
  ];

  const batchCompletionRates = [
    { period: 'Aujourd\'hui', completed: metrics?.completedToday || 0, target: 15 },
    { period: 'Cette semaine', completed: 42, target: 75 },
    { period: 'Ce mois', completed: 156, target: 300 }
  ];

  return (
    <div className="space-y-6">
      {/* Operator Performance */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Performance Opérateurs</h3>
        <div className="space-y-4">
          {operatorPerformance?.map(operator => (
            <div key={operator?.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-semibold text-gray-900">{operator?.name}</div>
                  <div className="text-sm text-gray-600">{operator?.id}</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-gray-900">{operator?.batches}</div>
                  <div className="text-xs text-gray-600">lots traités</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-sm text-gray-600 mb-1">Efficacité</div>
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-primary rounded-full h-2"
                        style={{ width: `${operator?.efficiency}%` }}
                      />
                    </div>
                    <span className="text-sm font-semibold text-gray-900">{operator?.efficiency}%</span>
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Qualité</div>
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-success rounded-full h-2"
                        style={{ width: `${operator?.quality}%` }}
                      />
                    </div>
                    <span className="text-sm font-semibold text-gray-900">{operator?.quality}%</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Machine Efficiency */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Efficacité Machines</h3>
        <div className="space-y-4">
          {machineEfficiency?.map(machine => (
            <div key={machine?.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="font-semibold text-gray-900">{machine?.name}</div>
                  <div className="text-sm text-gray-600">{machine?.id}</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-gray-900">{machine?.batches}</div>
                  <div className="text-xs text-gray-600">lots produits</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-sm text-gray-600 mb-1">Utilisation</div>
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-primary rounded-full h-2"
                        style={{ width: `${machine?.utilization}%` }}
                      />
                    </div>
                    <span className="text-sm font-semibold text-gray-900">{machine?.utilization}%</span>
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">Disponibilité</div>
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div
                        className="bg-success rounded-full h-2"
                        style={{ width: `${machine?.uptime}%` }}
                      />
                    </div>
                    <span className="text-sm font-semibold text-gray-900">{machine?.uptime}%</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Batch Completion Rates */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Taux de Complétion</h3>
        <div className="space-y-4">
          {batchCompletionRates?.map((rate, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{rate?.period}</span>
                <span className="text-sm text-gray-600">
                  {rate?.completed} / {rate?.target}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className="bg-primary rounded-full h-3 transition-all duration-300"
                  style={{ width: `${(rate?.completed / rate?.target) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* QR Scan Data Integration */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Intégration Données QR</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-primary/5 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="QrCode" size={20} className="text-primary" />
              <span className="font-semibold text-gray-900">Scans par opérateur</span>
            </div>
            <div className="text-2xl font-bold text-gray-900">Moyenne: 8.5</div>
            <div className="text-sm text-gray-600">Scans par jour</div>
          </div>
          <div className="bg-success/5 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Clock" size={20} className="text-success" />
              <span className="font-semibold text-gray-900">Temps moyen</span>
            </div>
            <div className="text-2xl font-bold text-gray-900">4.2h</div>
            <div className="text-sm text-gray-600">Par phase de production</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMonitoring;